import React, { useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";

export default function AAConfirmation({ open, setOpen, phone, onConfirm, theme }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedPhone, setEditedPhone] = useState(phone);
  const [error, setError] = useState("");
  
  const handleInputChange = (e) => {
    const value = e.target.value;
    setEditedPhone(value);

    // Validate phone number
    if (!/^\d{10}$/.test(value)) {
      setError("Phone number must be exactly 10 digits.");
    } else {
      setError("");
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditedPhone(phone); // Reset phone number to original
    setError(""); // Clear any errors
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        setIsEditing(false); // Reset editing state on close
        setOpen(false);
        setError(""); // Clear any errors
      }}
      className="relative z-10"
    >
      <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

      <div className="fixed inset-0 z-10 flex items-center justify-center p-4">
        <DialogPanel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 shadow-xl">
          <DialogTitle as="h3" className="text-lg font-medium text-gray-900">
            Confirm your bank-connected phone
          </DialogTitle>
          <div className="mt-4">
            {isEditing ? (
              <input
                type="text"
                value={editedPhone}
                onChange={handleInputChange}
                className="text-black w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500"
              />
            ) : (
              <p className="text-sm text-gray-500">
                We will verify your bank-connected phone: <b>{phone}</b>.
              </p>
            )}
            {error && <p className="text-sm text-red-500 mt-2">{error}</p>}
          </div>
          <div className="mt-4 flex justify-end gap-4">
            {isEditing ? (
              <button
                onClick={handleCancel}
                className="px-4 py-2 text-sm font-semibold text-gray-900 border border-gray-300 rounded-md hover:bg-gray-50"
              >
                Cancel
              </button>
            ) : (
              <button
                onClick={() => {
                  setIsEditing(true);
                  setEditedPhone(phone); // Pre-fill input with current phone number
                }}
                className="px-4 py-2 text-sm font-semibold text-gray-900 border border-gray-300 rounded-md hover:bg-gray-50"
              >
                Edit
              </button>
            )}
            <button
              onClick={() => {
                onConfirm(editedPhone); // Pass the edited phone number
                setIsEditing(false); // Reset editing state after confirm
              }}
              disabled={error} // Disable button if there's an error or empty input
              className={`px-4 py-2 text-sm font-semibold text-white rounded-md ${
                error
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-black hover:bg-gray-800"
              }`}
            >
              Confirm
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
